
<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();

onMounted(() => {
   setTimeout(() => {
      router.push({ name: 'dashboard' });
   }, 3000);
})

</script>

<template>
    <div class="relative">
        <div class="absolute bg-[#FFA2BE80] w-[400px] h-[400px] bottom-[-5%] right-[-15%] rounded-full" style="filter: blur(177px);"></div>
        <div class="absolute bg-[#FE8D2366] w-[400px] h-[400px] bottom-[-10%] right-[10%] rounded-full" style="filter: blur(177px);"></div>
        <div class="absolute bg-[#5009F74D] w-[400px] h-[400px] bottom-[-15%] right-[30%] rounded-full" style="filter: blur(177px);"></div>

        <div class="px-3 md:pr-0 lg:pl-[20%] flex justify-center flex-col h-screen w-full">
            <svg width="73" height="18" viewBox="0 0 73 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5" transform="translate(0, 4)">
                    <circle cx="5" cy="5" r="5" fill="#101828">
                        <animate attributeName="cy" values="5;1;5" dur="1s" repeatCount="indefinite" />
                    </circle>
                    <circle cx="47" cy="5" r="5" fill="#101828">
                        <animate attributeName="cy" values="5;1;5" dur="1s" begin="0.2s" repeatCount="indefinite" />
                    </circle>
                    <circle cx="68" cy="5" r="5" fill="#101828">
                        <animate attributeName="cy" values="5;1;5" dur="1s" begin="0.4s" repeatCount="indefinite" />
                    </circle>
                    <circle cx="26" cy="5" r="5" fill="#101828">
                        <animate attributeName="cy" values="5;9;5" dur="1s" begin="0.6s" repeatCount="indefinite" />
                    </circle>
                </g>
            </svg>
            
            <div class="text-[#101828] text-2xl lg:text-[28px] font-semibold mt-10">Preparing Your Experience</div>
            <div class="text-[#344054] text-base font-normal mt-5 md:w-[600px]">We’re setting up your experience to ensure everything works
                smoothly. This won’t take long—thank you for your patience!</div>
        </div>
    </div>
</template>


<style scoped>
/* .circle{
    position: absolute;
    width: 466px;
    height: 466px;
    border-radius: 100%;
    background: #ffa2be80;
    filter: blur(177px);
    transform: rotate(15deg);
} */
/* .circle-1 {
    position: absolute;
    width: 466px;
    height: 466px;
    border-radius: 100%;
    filter: blur(177px);
    transform: rotate(15deg);
    background: #FFA2BE80;
    left: 60%;
    bottom: 0;
}
.circle-2 {
    background: #FE8D2366;
    left: 80%;
    bottom: 0;
}
.circle-3 {
    background: #5009F74D;
    left: 110%;
    bottom: 0;
} */
</style>